export default {
  // 查询当前支付厂商
  query_getCurrentVendor: {
    type: "formDataPost"
  },
  merchant_findAllVendor: {
    type: "formDataPost"
  },
  merchant_changePayVendor: {
    type: "formDataPost"
  },
  //获取待支付金额
  query_queryWaitingForPaymentAmount: {
    type: "formDataPost"
  },
  query_pay_queryBalance: {
    type: "post"
  },
  merchant_findVendorBalance: {
    type: "post"
  },
  sup_merchant_findAllMerchant: {
    type: "formDataPost"
  },
  sup_merchant_switchMerchant: {
    type: "formDataPost"
  },
  //logout
  user_logout: {
    type: "formDataPost"
  }
};



// WEBPACK FOOTER //
// ./src/service/modules/common.js